/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable react/forbid-prop-types */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { GNOMAD_POPULATIONS } from "../../../../common/helpers/Constant";
import { cropNumber } from "../../../../common/helpers/helpers";
import {
  getVarsomeHost,
  getGenomeName,
} from "../../../../state/selectors/general.selectors";
import { getProp } from "./helpers";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import { getZscoreColor } from "../common/helpers";
import { VARIANTS_TYPES, CONSTRAINT_FLAGS } from "../common/constants";
import HelperText from "../../../../components/atoms/HelperText";

const { string, number, shape, any } = PropTypes;

const createFirstDataTable = (item, varsomeHost, genomeName) => {
  let table = {};
  const center = { textAlign: "center" };
  const centerBold = { textAlign: "center", fontWeight: "bold" };
  const header = (
    <thead>
      <tr>
        <th style={centerBold}>Gene</th>
        <th style={centerBold}>
          Type <HelperText fieldDescriptionKey="Type" />
        </th>
        <th style={centerBold}>
          BioType
          <HelperText fieldDescriptionKey="BioType" />
        </th>
        <th style={centerBold}>
          Transcript
          <HelperText fieldDescriptionKey="Transcript" />
        </th>
        <th style={centerBold}>
          Coding exons
          <HelperText fieldDescriptionKey="Coding exons" />
        </th>
        <th style={centerBold}>
          Length
          <HelperText fieldDescriptionKey="Length" />
        </th>
      </tr>
    </thead>
  );
  const row = (
    <tr>
      <td style={center}>{item.gene ? item.gene : "-"}</td>
      <td style={center}>
        {item.transcript_type ? item.transcript_type : "-"}
      </td>
      <td style={center}>{item.gene_type ? item.gene_type : "-"}</td>
      <td style={center}>
        {item.transcript ? (
          <a
            href={`${varsomeHost}/transcript/${genomeName}/${item.transcript}`}
          >
            {item.transcript}
          </a>
        ) : (
          "-"
        )}
      </td>
      <td style={center}>
        {item.num_coding_exons ? item.num_coding_exons : "-"}
      </td>
      <td style={center}>{item.gene_length ? item.gene_length : "-"}</td>
    </tr>
  );
  table = (
    <div className="tw-mt-4">
      <table className="varsome-table tw-break-words">
        {header}
        <tbody className="varsome-text-center">{row}</tbody>
      </table>
    </div>
  );
  return table;
};

const createSecondDataTable = (item) => {
  let table = {};
  const center = { textAlign: "center" };
  const header = (
    <thead>
      <tr>
        <th style={center}>
          Probability
          <br />
          LOF Intolerant
          <HelperText fieldDescriptionKey="Probability LOF Intolerant" />
        </th>
        <th style={center}>
          Probability
          <br />
          LOF Recessive
          <HelperText fieldDescriptionKey="Probability LOF Recessive" />
        </th>
        <th style={center}>
          Probability
          <br />
          LOF Tolerant
          <HelperText fieldDescriptionKey="Probability LOF Tolerant" />
        </th>
        <th style={center}>
          Individuals with
          <br />
          no LOFs
          <HelperText fieldDescriptionKey="Individuals with no LOFs" />
        </th>
        <th style={center}>
          Individuals with
          <br />
          Homozygous LOFs
          <HelperText fieldDescriptionKey="Individuals with Homozygous LOFs" />
        </th>
        <th style={center}>
          Individuals with
          <br />
          Heterozygous LOFs
          <HelperText fieldDescriptionKey="Individuals with Heterozygous LOFs" />
        </th>
        <th style={center}>
          Defined
          <HelperText fieldDescriptionKey="Defined" />
        </th>
        <th style={center}>
          p<HelperText fieldDescriptionKey="p" />
        </th>
      </tr>
    </thead>
  );
  const row = (
    <tr>
      <td>{item.pli ? getProp(cropNumber(item.pli)) : "-"}</td>
      <td>{item.prec ? getProp(cropNumber(item.prec)) : "-"}</td>
      <td>{item.pnull ? getProp(cropNumber(item.pnull)) : "-"}</td>
      <td>{item.no_lofs ? cropNumber(item.no_lofs) : "-"}</td>
      <td>{item.obs_hom_lof ? cropNumber(item.obs_hom_lof) : "-"}</td>
      <td>{item.obs_het_lof ? cropNumber(item.obs_het_lof) : "-"}</td>
      <td>{item.defined ? Math.floor(cropNumber(item.defined + 0.5)) : "-"}</td>
      <td>{item.p ? cropNumber(item.p) : "-"}</td>
    </tr>
  );
  table = (
    <div style={{ marginTop: "2rem" }}>
      <table
        className="varsome-table"
        style={{ wordWrap: "break-word", overflowWrap: "break-word" }}
      >
        {header}
        <tbody className="varsome-text-center">{row}</tbody>
      </table>
    </div>
  );
  return table;
};

const createVariantsTable = (item) => {
  let variantsTable = {};
  let row = null;
  const rows = [];
  const right = { textAlign: "right" };
  const rightBold = { textAlign: "right", fontWeight: "bold" };
  const left = { textAlign: "left" };
  const leftBold = { textAlign: "left", fontWeight: "bold" };
  const header = (
    <thead>
      <tr>
        <th width="10%" style={leftBold} />
        <th width="10%" style={rightBold}>
          Z-Score <HelperText fieldDescriptionKey="Z-Score" />
        </th>
        <th width="10%" style={rightBold}>
          Observed <HelperText fieldDescriptionKey="Observed" />
        </th>
        <th width="10%" style={rightBold}>
          Expected <HelperText fieldDescriptionKey="Expected" />
        </th>
        <th width="11%" style={leftBold}>
          Observed/Expected{" "}
          <HelperText fieldDescriptionKey="Observed/Expected" />
        </th>
        <th width="12%" style={leftBold}>
          Lower
          <br />
          Bound
          <HelperText fieldDescriptionKey="Lower Obs/Exp Bound" />
        </th>
        <th width="12%" style={leftBold}>
          Upper
          <br />
          Bound
          <HelperText fieldDescriptionKey="Upper Obs/Exp Bound" />
        </th>
        <th width="10%" style={leftBold}>
          Mutation Rate <HelperText fieldDescriptionKey="Mutation Rate" />
        </th>
        <th width="15%" style={rightBold}>
          Total Possible in Transcript{" "}
          <HelperText fieldDescriptionKey="Total Possible in Transcript" />
        </th>
      </tr>
    </thead>
  );

  VARIANTS_TYPES.forEach((variantType, j) => {
    const zScore = item[`${variantType.suffix}_z`];
    const observed = item[`obs_${variantType.suffix}`];
    const expected = item[`exp_${variantType.suffix}`];
    const observeExpected = item[`oe_${variantType.suffix}`];
    const observeExpectedLower = item[`oe_${variantType.suffix}_lower`];
    const observeExpectedUpper = item[`oe_${variantType.suffix}_upper`];
    const mutation = item[`mu_${variantType.suffix}`];
    const possible = item[`possible_${variantType.suffix}`];

    row = (
      <tr key={`${variantType.suffix}_${j}`}>
        <td style={rightBold}>{variantType.name}</td>
        <td
          style={{
            color: getZscoreColor(zScore),
            textAlign: "right",
          }}
        >
          {zScore ? cropNumber(zScore, 3) : "-"}
        </td>
        <td style={right}>{observed ? cropNumber(observed) : "-"}</td>
        <td style={right}>{expected ? cropNumber(expected, 1) : "-"}</td>
        <td style={left}>
          {observeExpected ? cropNumber(observeExpected) : "-"}
        </td>
        <td style={left}>
          {observeExpectedLower ? cropNumber(observeExpectedLower) : "-"}
        </td>
        <td style={left}>
          {observeExpectedUpper ? cropNumber(observeExpectedUpper) : "-"}
        </td>
        <td style={left}>{mutation ? cropNumber(mutation) : "-"}</td>
        <td style={right}>{possible ? cropNumber(possible) : "-"}</td>
      </tr>
    );
    rows.push(row);
  });

  variantsTable = (
    <div style={{ marginTop: "2rem" }}>
      <table
        className="varsome-table"
        style={{ wordWrap: "break-word", overflowWrap: "break-word" }}
      >
        {header}
        <tbody className="varsome-text-center">{rows}</tbody>
      </table>
    </div>
  );

  return variantsTable;
};

const createPopulationsTable = (item) => {
  let populationsTable = {};
  let row = null;
  const rows = [];
  const right = { textAlign: "right" };
  const left = { textAlign: "left" };

  const header = (
    <thead>
      <tr>
        <th style={left}>Ethnicity</th>
        <th style={left}>
          Sum of pLOFs
          <HelperText fieldDescriptionKey="Sum of pLOFs" />
        </th>
        <th style={left}>
          p<HelperText fieldDescriptionKey="p" />
        </th>
      </tr>
    </thead>
  );

  GNOMAD_POPULATIONS.forEach((population, j) => {
    if (population.gene_name) {
      const ethnicity = population.gene_name;
      const sumPlofs = item[`classic_caf_${population.suffix}`]
        ? cropNumber(item[`classic_caf_${population.suffix}`] * 100, 3)
        : null;
      const p = item[`p_${population.suffix}`]
        ? cropNumber(item[`p_${population.suffix}`] * 100, 3)
        : null;
      if (sumPlofs || p) {
        row = (
          <tr key={`ethnicity_${j}`}>
            <td style={right}>{ethnicity}</td>
            <td style={left}>{sumPlofs || "-"}%</td>
            <td style={left}>{p || "-"}%</td>
          </tr>
        );
        rows.push(row);
      }
    }
  });

  populationsTable = (
    <div style={{ marginTop: "2rem", textAlign: "center" }}>
      <h5>Population frequencies</h5>
      <table
        className="varsome-table"
        style={{
          wordWrap: "break-word",
          overflowWrap: "break-word",
          width: "60%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {header}
        <tbody className="varsome-text-center">{rows}</tbody>
      </table>
    </div>
  );

  return populationsTable;
};

const GnomadGenesV2 = ({ gnomadEntry, hostUrl, genomeName }) => {
  if (!gnomadEntry) return null;

  const variantsTable = createVariantsTable(gnomadEntry);
  const ethnicityTable = createPopulationsTable(gnomadEntry);
  const firstDataTable = createFirstDataTable(gnomadEntry, hostUrl, genomeName);
  const secondDataTable = createSecondDataTable(gnomadEntry);

  return (
    <div style={{ marginBottom: "5rem" }}>
      {gnomadEntry.constraint_flag && (
        <div className="varsome-horiz-flex">
          <div className="varsome-horiz-list-item">
            <div className="varsome-horiz-list-label">
              Constraint Flag{" "}
              <HelperText fieldDescriptionKey="Constraint Flag" />
            </div>
            <div className="varsome-horiz-list-value">
              {gnomadEntry.constraint_flag}
            </div>
          </div>
          <div className="varsome-horiz-list-item">
            <div className="varsome-horiz-list-label">Explanation</div>
            <div className="varsome-horiz-list-value">
              {CONSTRAINT_FLAGS.map((flag) => {
                if (flag.type === gnomadEntry.constraint_flag) {
                  return flag.explanation;
                }
              })}
            </div>
          </div>
        </div>
      )}
      {firstDataTable}
      {secondDataTable}
      {variantsTable}
      {ethnicityTable}
    </div>
  );
};

GnomadGenesV2.propTypes = {
  gnomadEntry: shape({
    cds_length: number,
    chromosome: string,
    classic_caf: number,
    classic_caf_afr: number,
    classic_caf_amr: number,
    classic_caf_asj: number,
    classic_caf_eas: number,
    classic_caf_fin: number,
    classic_caf_nfe: number,
    classic_caf_oth: number,
    classic_caf_sas: number,
    constraint_flag: any,
    defined: number,
    ensembl_gene_id: string,
    exp_hom_lof: number,
    exp_lof: number,
    exp_mis: number,
    exp_mis_pphen: number,
    exp_syn: number,
    gene: string,
    gene_length: number,
    gene_type: string,
    lof_z: number,
    max_af: number,
    mis_z: number,
    mu_lof: number,
    mu_mis: number,
    mu_syn: number,
    n_sites: number,
    no_lofs: number,
    num_coding_exons: number,
    obs_het_lof: number,
    obs_hom_lof: number,
    obs_lof: number,
    obs_mis: number,
    obs_mis_pphen: number,
    obs_syn: number,
    oe_lof: number,
    oe_lof_lower: number,
    oe_lof_upper: number,
    oe_lof_upper_bin: number,
    oe_lof_upper_bin_6: number,
    oe_lof_upper_rank: number,
    oe_mis: number,
    oe_mis_lower: number,
    oe_mis_pphen: number,
    oe_mis_upper: number,
    oe_syn: number,
    oe_syn_lower: number,
    oe_syn_upper: number,
    p: number,
    p_afr: number,
    p_amr: number,
    p_asj: number,
    p_eas: number,
    p_fin: number,
    p_nfe: number,
    p_oth: number,
    p_sas: number,
    pli: number,
    pnull: number,
    possible_lof: number,
    possible_mis: number,
    possible_mis_pphen: number,
    possible_syn: number,
    prec: number,
    syn_z: number,
    transcript: string,
    transcript_level: number,
    transcript_type: string,
  }),
  hostUrl: PropTypes.string,
  genomeName: PropTypes.string,
};

GnomadGenesV2.defaultProps = {
  gnomadEntry: null,
  hostUrl: null,
  genomeName: null,
};

const mapStateToProps = (state) => ({
  hostUrl: getVarsomeHost(state),
  genomeName: getGenomeName(state),
});

export default connect(mapStateToProps)(
  withErrorGuard(GnomadGenesV2, "gnomadGenes", "GnomAD Genes")
);
